import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { TrackingMapPage } from './TrackingMapPage';

const MapRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<TrackingMapPage />} />
        </Routes>
    );
};

export default MapRoutes;
